export default __webpack_public_path__ + "static/media/03 - About.aspx (1).68974e5c.png";